import script from "./ConversationalForms.vue?vue&type=script&lang=js"
export * from "./ConversationalForms.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__